import React, {useContext, useEffect, useState} from "react";
import {OrganizationRepository} from "../../repositories/OrganizationRepository";
import {toast} from "react-toastify";
import {
  Autocomplete,
  Avatar,
  Box, Button, Dialog, DialogActions,
  DialogContent,
  DialogTitle, Grid,
  IconButton,
  Stack, Switch, Table, TableBody, TableCell, TableHead, TableRow,
  TextField, Tooltip, Typography
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Add01Icon, Delete02Icon, PencilEdit01Icon} from "@hugeicons/core-free-icons";
import axios from "../../config/axios";
import {SignInContext, TOKEN} from "../../context/SignInContext";
import useConfirm from "../../hooks/useConfirm";
import {v4 as uuid} from "uuid";
import {uploadImage} from "../../utils/uploadImage";
import moment from "moment";


export const Organizations = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const {currentUser, organizations, updateOrganizations} = useContext(SignInContext);

  const confirmDelete = useConfirm(
    'Are you sure you want to delete this organization?',
  );

  useEffect(() => {
    if (!organizations?.length) {
      updateOrganizations();
    }
  }, [])


  useEffect(() => {
    console.log(organizations)
  }, [organizations])
  const onPublish = (id) => {
    OrganizationRepository.publish(id)
      .then(() => {
        // toast.success("Successfully published organization");
        updateOrganizations();
      })
      .catch(error => {
        toast.error("Failed to publish organization");
      })
  }

  const handleDelete = async (id) => {
    const response = await confirmDelete({title: "Are you sure you want to delete this organization?"});
    if (response) {
      OrganizationRepository.delete(id)
        .then(() => {
          toast.success("Successfully deleted organization");
          updateOrganizations();
        })
        .catch(error => {
          toast.error("Failed to delete organization");
        })
    }
  }

  return (
    <>
      <CreateOrganization
        handleClose={() => {
          setOpenModal(false);
          setSelectedOrganization(null);
        }}
        open={openModal}
        selectedOrganization={selectedOrganization}
        onSuccess={updateOrganizations}
      />
      <Grid maxWidth={"lg"} sx={{mx: "auto", p: 3, my: 5, borderRadius: 4, bgcolor: "#fefefeee"}} container className={"border-shadow"}>
        <Grid item sm={12}>
          <Stack direction={"row"} gap={1} justifyContent={"space-between"} alignItems={"center"}>
            <Box maxWidth={"md"}>
              <Typography variant={"h4"} fontWeight={600}>Organizations</Typography>
            </Box>
            <Button
              sx={{boxShadow: 0}}
              className={"text-primary-gradient"}
              onClick={() => {
                setOpenModal(true);
                setSelectedOrganization(null);
              }}
              startIcon={<HugeiconsIcon icon={Add01Icon} size={18}/>}
            >
              Create Organization
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight: 700}}>Name</TableCell>
                <TableCell sx={{fontWeight: 700}}>Type</TableCell>
                <TableCell sx={{fontWeight: 700}}>Members</TableCell>
                <TableCell sx={{fontWeight: 700}}>Date Created</TableCell>
                <TableCell sx={{fontWeight: 700}}>Published</TableCell>
                <TableCell sx={{fontWeight: 700}}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {organizations?.map(organization => {
                return (
                  <TableRow key={organization?.id}>

                    <TableCell>
                      <Typography>{organization?.name}</Typography>
                      <Typography variant={"body2"} fontSize={11} noWrap>{organization?.description}</Typography>
                    </TableCell>
                    <TableCell>{organization?.type}</TableCell>
                    <TableCell>
                      <Tooltip title={organization?.members?.map(i => i?.member)?.join(", ")}>
                        {organization?.members?.length}
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      {moment(organization?.createdAt).format("DD MMM YYYY")}
                    </TableCell>
                    <TableCell padding={"checkbox"}>
                      <Switch
                        checked={!!organization?.published}
                        onChange={() => onPublish(organization?.id)}
                      />
                    </TableCell>
                    <TableCell padding={"checkbox"}>
                      <Stack direction={"row"} gap={1} justifyContent={"space-between"} sx={{pb: 0.5}}
                             alignItems={"flex-start"}>
                        <IconButton
                          variant={"contained"} sx={{borderRadius: "50% !important"}}
                          onClick={() => {
                            setSelectedOrganization(organization);
                            setOpenModal(true);
                          }}>
                          <HugeiconsIcon icon={PencilEdit01Icon} size={18} />
                        </IconButton>
                        <IconButton
                          variant={"contained"} color={"error"}
                          sx={{borderRadius: "50% !important"}}
                          onClick={() => handleDelete(organization?.id)}>
                          <HugeiconsIcon icon={Delete02Icon} size={18} />
                        </IconButton>
                      </Stack>

                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  )
}

export const CreateOrganization = ({open, handleClose, selectedOrganization, onSuccess}) => {
  const [organization, setOrganization] = useState({name: "", organization_type: "", members: [], published: false});
  const [users, setUsers] = useState([]);
  const [image, setImage] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get('/api/user/all', null, {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem(TOKEN)}`
          }
        });
        const users = response.data?.filter(u => u?.enabled);
        console.log(users);
        setUsers([...(new Set(users?.map(u => u.username)) || [])]);
      } catch (err) {
        toast.error("Failed to get users")
      }
    }
    fetchUsers();
  }, [])


  useEffect(() => {
    setOrganization({
      id: selectedOrganization?.id || null,
      name: selectedOrganization?.name || "",
      type: selectedOrganization?.type || "",
      published: selectedOrganization?.published || false,
      members: selectedOrganization?.members?.map(item => item?.member) || []
    });
    setImage(selectedOrganization?.img || null);
  }, [selectedOrganization])

  const onChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    onUpdate(key, value);
  }

  const onUpdate = (key, value) => {
    setOrganization(prev => ({...prev, [key]: value}))
  }

  const createImage = async () => {
    if (!image) {
      return;
    }
    const id = uuid();
    const url = `organizations/${id}-${image?.name}`;

    return await uploadImage({img: image, url: url});
  }

  const handleAddMember = (newUser) => {
    if (newUser && !organization?.members?.includes(newUser)) {
      setOrganization(prev => ({
        ...prev,
        members: [...(prev.members || []), newUser]
      }));
      setSelectedUser(null);
    }
  }

  const handleRemoveMember = (memberToRemove) => {
    setOrganization(prev => ({
      ...prev,
      members: prev.members.filter(member => member !== memberToRemove)
    }));
  }

  const availableUsers = users.filter(user => !organization?.members?.includes(user));
  console.log(users, availableUsers, organization.members)

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        sx: {minWidth: "320px", maxWidth: "sm", borderRadius: 4, p: 2, width: "100%", maxHeight: "65dvh", overflow: "hidden"},
        onSubmit: async (event) => {
          event.preventDefault();
          if (!organization?.name) {
            toast.error("Organization name is required!")
            return;
          }
          let img = null;
          if (image && typeof image === "object") {
            img = await createImage();
          }

          if (selectedOrganization?.id) {
            OrganizationRepository.edit(selectedOrganization?.id, {...organization, image: img})
              .then(response => {
                onSuccess();
                toast.success("Successfully updated organization");
                handleClose();
              })
              .catch(error => {
                toast.error(error?.message || "Failed to update organization");
              })
          } else {
            OrganizationRepository.create({...organization, img})
              .then(response => {
                onSuccess();
                toast.success("Successfully created organization");
                handleClose();
              })
              .catch(error => {
                toast.error(error?.message || "Failed to create organization");
              })
          }
        },
      }}
    >
      <DialogTitle>{selectedOrganization?.id ? "Update" : "Create"} Organization</DialogTitle>
      <DialogContent sx={{display: "flex", flexDirection: "column", gap: 2, py: "16px !important"}}>
          <TextField
            label={"Name"}
            required
            fullWidth
            name={"name"}
            value={organization?.name}
            onChange={onChange}
          />
          <TextField
            label={"Type"}
            required
            fullWidth
            name={"type"}
            value={organization?.type}
            onChange={onChange}
          />

          <Autocomplete
            renderInput={(props) => <TextField {...props} label={`Add Member`} placeholder="Search users..."/>}
            options={availableUsers}
            getOptionLabel={option => option}
            value={selectedUser}
            clearOnBlur
            blurOnSelect
            onChange={(e, newValue) => {
              handleAddMember(newValue);
            }}
            onBlur={() => setSelectedUser(null)}
          />
          <Box sx={{flex: 1, overflowY: "auto"}}>
            {/*<Typography variant={"body2"} sx={{ mb: 1, fontWeight: 600 }}>Members</Typography>*/}


            {organization?.members?.length > 0 && (
              <Table size="small" sx={{ mt: 2, border: 0, borderColor: "divider", borderRadius: "8px !important" }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600 }}>Username</TableCell>
                    <TableCell sx={{ fontWeight: 600 }} align="right"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {organization?.members?.map((member, index) => (
                    <TableRow key={index}>
                      <TableCell>{member}</TableCell>
                      <TableCell align="right">
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => handleRemoveMember(member)}
                        >
                          <HugeiconsIcon icon={Delete02Icon} size={16} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Box>
      </DialogContent>
      <DialogActions sx={{px: 2, py: 1}}>
        <Button variant="ghost" onClick={handleClose}>Cancel</Button>
        <Button type="submit" variant={'modal'}>
          {selectedOrganization?.id ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
